import {makeAutoObservable, observable} from 'mobx'
import {PromiseUtil} from 'yougile-util'
import {Storage} from '@client/storage'
import {createUseStore} from '@containers/hooks'
import {DialogProps} from '../dialog/dialog'

interface NotificationData {
  title: string
  subtitle?: string
  noShowMoreKey?: string | false
  dialogProps?: Partial<Omit<DialogProps, 'noShowMore' | 'noShowMoreTextCb'>>
  newDialog?: boolean
}

interface Notification extends NotificationData {
  resolve: (value: boolean) => void
}

interface State {
  notifications: Notification[]
}

export class NotificationsStore {
  state: State = {
    notifications: []
  }

  constructor() {
    makeAutoObservable(
      this,
      {
        state: observable.shallow
      },
      {autoBind: true}
    )
  }

  getNoShowMoreValue(notification: NotificationData): boolean {
    if (!notification.noShowMoreKey) {
      return false
    }
    return Storage.getItem(notification.noShowMoreKey) === '1'
  }

  setNoShowMoreValue(notification: NotificationData, value: boolean): void {
    if (!notification.noShowMoreKey) {
      return
    }
    Storage.setItem(notification.noShowMoreKey, value ? '1' : '0')
  }

  resolveNotification(notification: Notification, value: boolean): void {
    notification.resolve(value)
    if (!value) {
      this.setNoShowMoreValue(notification, false)
    }

    const index = this.state.notifications.indexOf(notification)
    this.state.notifications = [
      ...this.state.notifications.slice(0, index),
      ...this.state.notifications.slice(index + 1)
    ]
  }

  showConfirm(notification: NotificationData): Promise<boolean> {
    if (this.getNoShowMoreValue(notification)) {
      return Promise.resolve(true)
    }

    const [promise, resolve] = PromiseUtil.withResolvers<boolean>()

    this.state.notifications = [
      ...this.state.notifications,
      {...notification, resolve}
    ]

    return promise
  }
}

const [NotificationsContext, useNotificationsStore] =
  createUseStore(NotificationsStore)
export {NotificationsContext, useNotificationsStore}
